import { useCallback, useMemo, useState } from 'react'
import { useAtom } from 'jotai'
import { useDebounce } from '@node-space/hooks'
import { ComboboxItem } from '@node-space/ui-components'
import { SEARCH_INPUT_DEBOUNCE_TIME } from 'constants/General'
import { useCustomersQuery } from 'hooks/queries/Customers/useCustomersQuery'
import { Customer, CustomerStatus } from 'types/customers'
import { convertToWalletAtom } from '../../atoms/atoms'

export const useCustomersDropdown = (onCustomerChange?: (id: string) => void) => {
  const [, setConvertToWallet] = useAtom(convertToWalletAtom)
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, SEARCH_INPUT_DEBOUNCE_TIME)

  const queryValues = useMemo(
    () => ({
      search: debouncedQuery,
      size: 100,
      filters: {
        statuses: [CustomerStatus.VERIFIED],
      },
    }),
    [debouncedQuery]
  )
  const { data, isFetching } = useCustomersQuery(queryValues)
  const customerOptions: ComboboxItem[] = useMemo(() => {
    if (data?.content) {
      return (data.content as Customer[]).map(c => ({
        value: c.reference,
        leftText: c.name,
      }))
    }
    return []
  }, [data?.content])

  const onChangeCustomer = useCallback(
    (customerId: string) => {
      onCustomerChange?.(customerId)

      setConvertToWallet(undefined) // clears the selected toWallet cbb and state
    },
    [onCustomerChange]
  )

  return {
    setQuery,
    isFetching,
    customerOptions,
    onChangeCustomer,
    isEmpty: !isFetching && customerOptions.length === 0,
  }
}
